import type { DocPageContent } from '../docs-content'

const page = {
  order: 5,
  slug: 'media',
  title: '媒体库',
  description: '导入媒体、检查文件、生成代理、转录稿和字幕。',
  category: '核心编辑',
  sections: [
    {
      title: '导入方式',
      items: [
        '导入视频、音频、图片、GIF、SVG 和生成的素材。',
        '当浏览器支持拖放时，将媒体文件拖入媒体面板。',
        '使用"从 URL 导入媒体"导入直接媒体文件链接。',
      ],
    },
    {
      title: '媒体检查',
      items: [
        '使用媒体信息查看编码格式、尺寸、时长、帧率、大小、类型和转录状态。',
        '在编辑到时间线之前，先在源监视器中打开媒体。',
        '当项目库增大时，按类型对素材进行排序、筛选和分组。',
      ],
    },
    {
      title: '生成的辅助数据',
      items: [
        '为大体积视频文件生成代理。',
        '生成或刷新语音文本的转录稿。',
        '当文件包含字幕轨道时提取内嵌字幕。',
        '运行"AI 分析"以准备场景和字幕工作流程。',
      ],
    },
    {
      title: '媒体缺失',
      items: [
        '当文件需要更新浏览器权限时，使用"授权访问"。',
        '当源文件已移动时，使用"定位"或"定位文件夹"。',
        '仅当你打算稍后重新链接时，才使用"离线工作"。',
      ],
    },
  ],
} satisfies DocPageContent

export default page